import { IFileCustom, useInputFileCustom } from "./useInputFileCustom";
import { FileUploader } from "react-drag-drop-files";
import { useEffect } from "react";
import * as S from "./styles";
import { DropPlusIcon } from "./dropPlusIcon";

type InputFileCustomProps = {
  onChange: (file: File) => void;
  fileTypes: string[];
  label?: string;
  icon?: React.ReactNode;
};

export const InputFileCustom = ({
  onChange,
  fileTypes,
  label,
  icon,
}: InputFileCustomProps) => {
  return (
    <>
      <S.Container>
        <S.WrapperInputFile>
          <FileUploader
            dropMessageStyle={{
              backgroundColor: "#ECF0F8",
              borderRadius: 12,
              border: "none",
            }}
            handleChange={onChange}
            name="file"
            hoverTitle=" "
            types={fileTypes}
          >
            <S.DragDrop>
              <div>
                {icon ?? (
                  <DropPlusIcon
                    width={"auto"}
                    height={"auto"}
                    style={{ width: 50, minWidth: 50 }}
                  />
                )}
              </div>

              <div>
                {label ? (
                  <p>{label}</p>
                ) : (
                  <p>
                    Clique para <span>adicionar</span> ou <span>arraste</span> e{" "}
                    <span>solte</span> um arquivo de imagem ou áudio aqui.
                  </p>
                )}
              </div>
            </S.DragDrop>{" "}
          </FileUploader>
        </S.WrapperInputFile>
      </S.Container>
    </>
  );
};
